import { ApiFetcher, AppRoute, ParamsFromUrl, initClient } from '@ts-rest/core';

import { apiContract } from '@eluve/api-contract';

export const createTsRestClient = (
  baseUrl: string,
  options?: {
    credentials?: RequestCredentials;
    customFetch?: ApiFetcher;
  },
) => {
  const client = initClient(apiContract, {
    baseUrl,
    credentials: options?.credentials || 'include',
    baseHeaders: {},
    api: options?.customFetch,
  });

  const getEndpointUrl = <Route extends AppRoute>(
    route: Route,
    pathParams?: ParamsFromUrl<Route['path']>,
  ): string => {
    let path = route.path;
    if (pathParams) {
      for (const [key, value] of Object.entries(pathParams)) {
        path = path.replace(`:${key}`, String(value));
      }
    }
    return `${baseUrl}${path}`;
  };

  type ExtendedClientType = typeof client & {
    getEndpointUrl: typeof getEndpointUrl;
  };

  const extendedClient = client as ExtendedClientType;

  extendedClient.getEndpointUrl = getEndpointUrl;

  return extendedClient;
};

export type TsRestClient = ReturnType<typeof createTsRestClient>;
